import React, {Component} from "react";
import Container from "../../../../modules/commons/Container";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../Services/Api";
import CRMFollowUpTab from "./components/crmFollowUpTab";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {ACTIVITY_TYPE} from "../../../common/Constants";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../../Services/Utils";
import {
    loyaltyLevelOptions,
    memberLevelOptions, prospekCategoryOptions,
    prospekSourceOptions, prospekTypeOptions,
    specialCategoryOptions
} from "../config/constants";

class CRMFollowUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: {},
            modifyingVisible: false,
            activityType: null,
            selectedDate: null,
        };
    };

    async componentDidMount() {
        this.handleTriggerLoading();
        await this.fetchDataCabang();
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }))
                }
            }
        } catch (e) {
            console.log("errors", e);
        }
        this.handleTriggerLoading();
    };

    handleModifyingVisibility = async (at, id) => {
        this.handleTriggerLoading();
        if (id) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailFU,
                setError: this.props.setError,
                menuName: "CRM - Follow Up Prospect",
                args: id,
            });
            if (res.ok) {
                let body = res.data.data;
                const data = {
                    ...body,
                    name: body.prospect.name,
                    nik: body.prospect.nik,
                    address: body.prospect.address,
                    provinceId: mapToObjectDDL(body.prospect.province.provinceName, body.prospect.province.id),
                    kabkotId: mapToObjectDDL(body.prospect.kabKot.kabKotName, body.prospect.kabKot.kabKotId),
                    kecamatanId: mapToObjectDDL(body.prospect.kecamatan.kecamatanName, body.prospect.kecamatan.id),
                    kelurahanId: mapToObjectDDL(body.prospect.kelurahan.kelurahanname, body.prospect.kelurahan.id),
                    zipcode: mapToObjectDDL(body.prospect.kodePos, body.prospect.kodePos),
                    gender: mapToObjectDDL(body.prospect.gender?.value, body.prospect.gender?.key),
                    job1: mapToObjectDDL(body.prospect.job1.value, body.prospect.job1.key),
                    job2: mapToObjectDDL(body.prospect.job2?.value, body.prospect.job2?.key),
                    religion: mapToObjectDDL(body.prospect.religion.value, body.prospect.religion.key),
                    hpNumber1: body.prospect.hpNumber1,
                    hpNumber2: body.prospect.hpNumber2,
                    email: body.prospect.email,
                    facebook: body.prospect.facebook,
                    instagram: body.prospect.instagram,
                    linkedin: body.prospect.linkedin,
                    twitter: body.prospect.x,
                    tiktok: body.prospect.tiktok,
                    discCategory: mapToObjectDDL(body.prospect.discountCategory, body.prospect.discountCategory),
                    hobby: body.prospect.hobby?.map(h => mapToObjectDDL(h.value, h.key)),
                    interest: body.prospect.interest?.map(h => mapToObjectDDL(h.value, h.key)),
                    customerId: body.prospect.member.customerId,
                    memberLevel: memberLevelOptions.find(item => item.value === body.prospect.member.memberLevel),
                    loyaltyLevel: loyaltyLevelOptions.find(item => item.value === body.prospect.member.loyaltyMember),
                    specialCategory: specialCategoryOptions.find(item => item.value === body.prospect.member.specialCategory),
                    specialNotes: body.prospect.member.specialNotes,
                    photoCustomerUrl: body.prospect.member.photoCustomerUrl,
                    prospectId: body.prospectId,
                    kodeCabang: body.kodeCabang.kodeCabang,
                    prospectDate: body.prospectDate,
                    category: prospekCategoryOptions.find(item => item.value === body.prospect.prospectCategory),
                    source: prospekSourceOptions.find(item => item.value === body.prospect.prospectSource),
                    sourceCabang: body.prospect.sourceCabang?.kodeCabang,
                    lastFollowUpBy: body.prospect.lastUpdateByUser?.name,
                    type: prospekTypeOptions.find(item => item.value === body.prospect.type),
                    prospectOwnership: body.prospect.userProspectOwner.name,
                    lastSeller: body.prospect.userLastSeller?.name,
                };
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: data,
                    activityType: at,
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                activityType: at,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleSetState = (callback) => {
        this.setState(callback);
    };

    handleChangeKodeCabang = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: value,
        }))
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView column>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value) => this.handleChangeKodeCabang(value)}
                        />
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>NON FOLLOW UP</Tab>
                            <Tab>ONGOING</Tab>
                            <Tab>PENDING</Tab>
                            <Tab>DROP</Tab>
                            <Tab>DEATH</Tab>
                            <Tab>DEAL</Tab>
                        </TabList>
                        <TabPanel key={"NON_FOLLOW_UP"}>
                            <CRMFollowUpTab title="NON FOLLOW UP" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="NON_FOLLOW_UP" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                        <TabPanel key={"ONGOING"}>
                            <CRMFollowUpTab title="ONGOING" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="ONGOING" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                        <TabPanel key={"PENDING"}>
                            <CRMFollowUpTab title="PENDING" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="PENDING" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                        <TabPanel key={"DROP"}>
                            <CRMFollowUpTab title="DROP" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="DROP" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                        <TabPanel key={"DEATH"}>
                            <CRMFollowUpTab title="DEATH" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="DEATH" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                        <TabPanel key={"DEAL"}>
                            <CRMFollowUpTab title="DEAL" {...this.props}
                                            triggerLoading={this.handleTriggerLoading}
                                            tab="DEAL" onSetState={this.handleSetState}
                                            handleModifyingVisibility={this.handleModifyingVisibility}
                                            state={this.state} kodeCabang={this.state.kodeCabang}
                                            menuAccess={this.props.menuAccess}/>
                        </TabPanel>
                    </Tabs>
                    <FlexView style={{justifyContent: "end"}}>
                        <SimpleButton
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.CREATE)}
                        >
                            Tambah
                        </SimpleButton>
                    </FlexView>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CRMFollowUp);